import {AppDocSystemStatusGroups} from '../../types/document/status'

export const docStatusGroups = Object.freeze({
    scanning: {
        key: AppDocSystemStatusGroups.SCANNING,
        label: 'Scanning',
        draggable: false
    },
    review: {
        key: AppDocSystemStatusGroups.REVIEW,
        label: 'Review',
        draggable: false
    },
    active: {
        key: AppDocSystemStatusGroups.ACTIVE,
        label: 'Active',
        draggable: false
    },
    approve: {
        key: AppDocSystemStatusGroups.APPROVE,
        label: 'Approval',
        draggable: false
    },
    complete: {
        key: AppDocSystemStatusGroups.COMPLETE,
        label: 'Complete',
        draggable: false
    }
})

export const docStatusGroupsList = Object.freeze(Object.values(docStatusGroups))
